import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { PackagesGridController } from '../controller/PackagesGridController';

export class PackagesGridWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: PackagesGridController,
    });
  }

  public async reload(resetSelectionStore = false, forceResetSelectionStore = false) {
    await this.controller?.view.dom.$grid.controller.handleGridItemsLoad(resetSelectionStore, forceResetSelectionStore);
  }
}
